










import Vue from 'vue';

export default Vue.extend({
  props: ['value', 'color'],
  computed: {
    customizedColorClass(): Record<string, boolean> {
      switch (this.color) {
        case 'red':
          return { red: true };
        case 'orange':
          return { orange: true };
        default:
          return { default: true };
      }
    },
  },
  methods: {
    updateCheckBox: function (
      event: Event & { target: HTMLInputElement },
    ): void {
      const { target } = event;
      if (target) {
        this.$emit('input', target.checked);
      }
    },
  },
});
